import HologramCard from '../../../components/base/HologramCard';
import GlitchText from '../../../components/base/GlitchText';

export default function AboutSection() {
  return (
    <section id="about" className="min-h-screen py-20 bg-gradient-to-b from-black to-gray-900">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-white font-orbitron mb-4">
            <GlitchText text="CPU CORE" />
          </h2>
          <div className="text-xl text-cyan-400 font-mono mb-2">PROCESSING UNIT ANALYSIS</div>
          <p className="text-gray-400 font-rajdhani text-lg">Core specifications and capabilities</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Profile Image */}
          <div className="relative">
            <HologramCard glowColor="cyan" className="p-8">
              <div className="text-center">
                <img 
                  src="https://static.readdy.ai/image/9be9028b55203ebd765bf33851a55a8d/11750a71246d9a99155fff4c34b15a99.jpeg"
                  alt="Aditya Prakash"
                  className="w-48 h-48 mx-auto rounded-full border-4 border-cyan-400 shadow-lg shadow-cyan-400/50 mb-6"
                />
                <div className="space-y-2">
                  <h3 className="text-2xl font-bold text-white font-orbitron">ADITYA PRAKASH</h3>
                  <div className="text-cyan-400 font-mono">PRODUCT_MANAGER.EXE</div>
                  <div className="text-gray-400 font-rajdhani">KIIT University</div>
                </div>
              </div>
            </HologramCard>
          </div>

          {/* About Content */}
          <div className="space-y-6">
            <HologramCard glowColor="green">
              <h3 className="text-xl font-bold text-white font-orbitron mb-4 flex items-center">
                <i className="ri-user-line text-green-400 mr-3"></i>
                SYSTEM OVERVIEW
              </h3>
              <p className="text-gray-300 font-rajdhani leading-relaxed">
                I'm a <strong className="text-cyan-400">Product Manager</strong> passionate about building customer-centric products. 
                Experienced in <strong className="text-green-400">product strategy</strong>, <strong className="text-orange-400">feature definition</strong>, and 
                <strong className="text-purple-400"> user research</strong>. Skilled in <strong className="text-blue-400">cross-functional collaboration</strong>, 
                <strong className="text-red-400"> metrics-driven decision making</strong>, and <strong className="text-cyan-400">iterative development</strong>.
              </p>
            </HologramCard>

            <HologramCard glowColor="purple">
              <h3 className="text-xl font-bold text-white font-orbitron mb-4 flex items-center">
                <i className="ri-graduation-cap-line text-purple-400 mr-3"></i>
                EDUCATION MODULE
              </h3>
              <div className="space-y-3">
                <div className="flex justify-between items-center">
                  <div>
                    <div className="text-white font-semibold">KIIT University</div>
                    <div className="text-purple-400 font-mono text-sm">Computer Science Engineering</div>
                  </div>
                  <div className="text-gray-400 font-mono text-sm">2022-2026</div>
                </div>
              </div>
            </HologramCard>

            <HologramCard glowColor="orange">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-xl font-bold text-white font-orbitron flex items-center">
                  <i className="ri-trophy-line text-orange-400 mr-3"></i>
                  CERTIFICATIONS
                </h3>
                <a 
                  href="https://www.linkedin.com/in/adityaprakash0302/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-400 font-rajdhani hover:text-blue-300 transition-colors underline text-sm"
                >
                  More Certifications
                </a>
              </div>
              <div className="space-y-2">
                <div className="flex items-center space-x-3">
                  <div className="w-2 h-2 bg-orange-400 rounded-full"></div>
                  <span className="text-gray-300 font-rajdhani">Product Management with Jira | Reliance Foundation</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-2 h-2 bg-cyan-400 rounded-full"></div>
                  <span className="text-gray-300 font-rajdhani">Google Project Management Specialization</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                  <span className="text-gray-300 font-rajdhani">AWS Academy Graduate - Cloud Architecting</span>
                </div>
              </div>
            </HologramCard>
          </div>
        </div>
      </div>
    </section>
  );
}
